<template>
  <filter-template
    @submit="filter()"
    @clear="clearFilter()"
  >
    <v-container
      class="pa-0"
    >
      <v-layout
        row
        wrap
      >
        <v-flex
          xs12
          md6
        >
          <date-picker
            v-model="payload.dataInicial"
            :rules="[dateLesserThan(payload.dataFinal)]"
            :label="$t('support.components.reports.initialDate')"
          />
        </v-flex>
        <v-flex
          xs12
          md6
        >
          <date-picker
            v-model="payload.dataFinal"
            :rules="[dateGreaterThan(payload.dataInicial)]"
            :label="$t('support.components.reports.finalDate')"
          />
        </v-flex>
        <v-flex
          xs12
          mb-2
        >
          <div
            class="headerSubtitle1"
          >
            {{ $t('support.components.reports.list.headers.tipo') }}
          </div>
        </v-flex>
        <v-flex>
          <input-select
            v-model="payload.tipo"
            item-text="label"
            item-value="value"
            :items="reportTypes"
            label="Selecione"
            :return-object="false"
            clearable
          />
        </v-flex>
      </v-layout>
    </v-container>
  </filter-template>
</template>

<script>
import FilterTemplate from 'Support/components/filter-component/FilterTemplate.vue';
import DatePicker from 'Support/components/pickers/DatePicker.vue';
import rulesMixin from 'Support/mixins/rules-mixin';
import FilterMixin from 'Support/mixins/FilterMixin';
import InputSelect from 'Support/components/inputs/InputSelect.vue';
import ReportListTypes from 'Support/enums/ReportListTypes';

export default {
  name: 'ReportFilterList',
  components: { FilterTemplate, DatePicker, InputSelect },
  mixins: [rulesMixin, FilterMixin],
  data() {
    return {
      reportTypes: ReportListTypes,
      payload: {
        dataFinal: '',
        dataInicial: '',
        tipo: '',
      },
    };
  },
};
</script>
